import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const ClinicalAminitiesNew: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M36.258 29.436H29.5723V39.5549H36.258V29.436Z" fill="white" />
    <path
      d="M28.458 42.3128V42.3857C28.458 43.0011 28.9569 43.5 29.5723 43.5H29.6454H36.1849H36.258C36.8734 43.5 37.3723 43.0011 37.3723 42.3857V42.3128V25.6714H28.458V42.3128ZM29.5723 29.436H36.258V39.5549H29.5723V29.436Z"
      fill="#002677"
    />
    <path
      d="M35.0274 34.0078H34.1675L33.7017 34.7494L32.9402 33.6781C32.966 33.6656 32.9901 33.652 33.0149 33.6378C33.2785 33.4887 33.4645 33.2303 33.5047 32.9283C33.5168 32.8385 33.5176 32.7477 33.508 32.6579C33.4804 32.4016 33.3636 32.1617 33.1486 32.0017C33.1247 31.9837 33.0998 31.9669 33.0741 31.9522C32.8858 31.8401 32.687 31.7993 32.3256 31.7993H30.6865V35.1944H31.4247V33.8609H32.1851L33.2263 35.3321L32.2035 36.8142H33.0753L33.6624 35.9611L34.2545 36.8142H35.1436L34.1051 35.3174L35.0274 34.0078ZM32.6108 33.2194C32.514 33.2907 32.3764 33.3162 32.1323 33.3162H31.4247V32.3847H32.1628C32.5956 32.3847 32.789 32.5273 32.789 32.8477C32.7889 33.011 32.7279 33.1378 32.6108 33.2194Z"
      fill="#002677"
    />
    <path
      d="M35.208 8.9571H10.6368V4.5H9.51465V18.9242H10.6368V15.6428H36.2574V18.9857H37.3717V11.121C37.3717 9.9256 36.403 8.9571 35.208 8.9571ZM16.5445 14.5122H10.6454V10.0877H16.5445V14.5122Z"
      fill="#FF612B"
    />
    <path
      d="M22.8861 38.4858C22.8861 40.6398 21.1401 42.3858 18.9861 42.3858C16.8322 42.3858 15.0861 40.6398 15.0861 38.4858V32.8578C17.5863 32.5771 19.5432 30.4742 19.5432 27.9001V22.3287C19.5432 21.7133 19.0443 21.2144 18.4289 21.2144H17.3146V22.3287H18.4289V27.9001C18.4289 30.0541 16.6829 31.8001 14.5289 31.8001C12.375 31.8001 10.6289 30.0541 10.6289 27.9001V22.3287H11.7432V21.2144H10.6289C10.0135 21.2144 9.51465 21.7133 9.51465 22.3287V27.9001C9.51465 30.4742 11.4715 32.5771 13.9717 32.8578V38.4858C13.9717 41.2508 16.2211 43.5001 18.986 43.5001C21.751 43.5001 24.0004 41.2509 24.0004 38.4858V36.8144H22.8861V38.4858Z"
      fill="#002677"
    />
    <path
      d="M37.3714 21.2144H28.4571C27.8417 21.2144 27.3428 21.7133 27.3428 22.3287V25.6716H38.4857V22.3287C38.4857 21.7133 37.9869 21.2144 37.3714 21.2144Z"
      fill="#FF612B"
    />
    <path
      d="M17.298 6.72852L10.6289 6.74482V8.95702H19.5266C19.5266 7.72632 18.5288 6.72852 17.298 6.72852Z"
      fill="#002677"
    />
    <path
      d="M23.4222 32.9067C22.1915 32.9067 21.1904 33.9089 21.1904 35.1396C21.1904 36.3703 22.1915 37.3714 23.4222 37.3714C24.6529 37.3714 25.6551 36.3703 25.6551 35.1396C25.6551 33.9089 24.6529 32.9067 23.4222 32.9067ZM23.4222 36.2571C22.8063 36.2571 22.3047 35.7555 22.3047 35.1396C22.3047 34.5226 22.8063 34.021 23.4222 34.021C24.0392 34.021 24.5408 34.5226 24.5408 35.1396C24.5408 35.7555 24.0392 36.2571 23.4222 36.2571Z"
      fill="#FF612B"
    />
    <path d="M16.5446 10.0879H10.6455V14.5124H16.5446V10.0879Z" fill="white" />
    <path
      d="M23.4228 36.2572C24.0403 36.2572 24.5409 35.7566 24.5409 35.1391C24.5409 34.5216 24.0403 34.021 23.4228 34.021C22.8053 34.021 22.3047 34.5216 22.3047 35.1391C22.3047 35.7566 22.8053 36.2572 23.4228 36.2572Z"
      fill="white"
    />
  </Box>
)

export default ClinicalAminitiesNew
